import { render, staticRenderFns } from "./depperbusdafi.vue?vue&type=template&id=3182325c&scoped=true&"
import script from "./depperbusdafi.vue?vue&type=script&lang=js&"
export * from "./depperbusdafi.vue?vue&type=script&lang=js&"
import style0 from "./depperbusdafi.vue?vue&type=style&index=0&id=3182325c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3182325c",
  null
  
)

export default component.exports